export default __webpack_public_path__ + "static/media/nature_white_male.0e8bd1fa.png";